const RADIAL_DUCT_FAIL_MESSAGES: Record<string, string> = {
  FR_TOO_LOW: 'the duct runs are too long for the available static pressure',
  FR_ABOVE_TABLE_MAX:
    'the duct layout falls outside the supported sizing range',
  SUPPLY_VEL_HIGH: 'supply air velocity would be too high (noisy)',
  SUPPLY_VEL_LOW: 'supply air velocity would be too low',
  SUPPLY_TERMINAL_OVERFLOW:
    'a supply run carries more air than one register can deliver (add parallel runs)',
  RETURN_VEL_HIGH: 'return air velocity would be too high (noisy)',
  AUTO_SIZE_FAIL: 'no stocked duct size can carry a supply run',
  RETURN_AUTO_SIZE_FAIL: 'no stocked duct size can carry the return run',
  NEGATIVE_STATIC_BUDGET:
    'the filter and fittings leave no static pressure for ductwork',
  EXCEEDS_AH_MAX_STATIC: 'the design static exceeds the air handler limit',
  NO_SUPPLY_RUNS: 'a room is missing a supply run'
};

export function describeRadialDuctFailReasons(
  reasons: string[]
): string | null {
  const unique = [...new Set(reasons)];
  if (unique.length === 0) return null;
  return unique
    .map((reason) => RADIAL_DUCT_FAIL_MESSAGES[reason] ?? reason)
    .join('; ');
}
